export default {
    apiKey: "AIzaSyBtnABm2KMw3KrTcIts7Blw6OVmoIGQgPc",
    authDomain: "item-card-generator.firebaseapp.com",
    databaseURL: "https://item-card-generator-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "item-card-generator",
    storageBucket: "item-card-generator.appspot.com",
    messagingSenderId: "862162214410",
    appId: "1:862162214410:web:16c8887b20490710a2c9f3"
}